import { Permission, DeliveryNoteDTO, DocumentType } from 'core/api';

import { showDocumentPayments } from 'pos/modules/helpers/payments-processing';
import { Command } from 'pos/common';
import * as DeliveryNoteStore from './DeliveryNoteStore';
import { DeliveryNoteFacade, PrintFacade } from 'pos/facades';
import { Preconditions } from 'core/infrastructure-next';

declare global {
	interface CommandType {
		showDeliveryNotePayments: (note: DeliveryNoteDTO) => Promise<Result>
	}
}

Command.register('showDeliveryNotePayments', Preconditions.ensureIsNotLite, async (note: DeliveryNoteDTO): Promise<Result> => {
	return showDocumentPayments({
		addPaymentPermission: Permission.DeliveryNote_AddPayment,
		removePaymentPermission: Permission.DeliveryNote_RefundPayment,
		getTicket: () => DeliveryNoteFacade.getTicket(note),
		updatePayments: (payments, prepayAmount) => DeliveryNoteStore.addPayments(note.Id, payments, prepayAmount),
		documentType: 'DeliveryNote',
		printDocument: async () => {
			const printParams = await PrintFacade.getPrintOptions(DocumentType.DeliveryNote);
			await DeliveryNoteStore.printDeliveryNote(note.Id, { contentReplacement: '', printer: printParams.Printer, printTemplate: printParams.Template });
		}
	});
});
